import {
    SiMeta,
    SiGoogle,
    SiTiktok,
    SiSnapchat,
} from "react-icons/si";
import { useSiteT } from "../../hooks/useSiteT";

const BingMark = () => (
    <span className="font-display font-black text-xl tracking-tight">b·</span>
);

const items = [
    { Icon: SiMeta, label: "Meta" },
    { Icon: SiGoogle, label: "Google" },
    { Icon: SiTiktok, label: "TikTok" },
    { Icon: SiSnapchat, label: "Snapchat" },
    { Icon: BingMark, label: "Bing" },
    { Icon: () => <span className="font-display font-bold tracking-wider">TABOOLA</span>, label: "Taboola" },
    { Icon: () => <span className="font-display font-bold tracking-wider">OUTBRAIN</span>, label: "Outbrain" },
];

export default function TrustBar() {
    const { t } = useSiteT();
    const track = [...items, ...items];
    return (
        <section
            data-testid="trust-bar"
            className="relative py-10 border-y border-white/5 overflow-hidden"
        >
            <div className="container-skala mb-6">
                <p className="text-center text-[11px] font-mono uppercase tracking-[0.3em] text-muted-foreground">
                    {t("tb.line")}
                </p>
            </div>
            <div className="relative">
                <div className="flex marquee-track gap-16 w-max">
                    {track.map(({ Icon, label }, idx) => (
                        <div
                            key={`${label}-${idx}`}
                            className="flex items-center gap-3 text-foreground/60 hover:text-foreground transition-colors min-w-fit"
                        >
                            <Icon className="w-7 h-7" />
                            <span className="font-display font-semibold text-lg tracking-wide">
                                {label}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent pointer-events-none" />
                <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent pointer-events-none" />
            </div>
        </section>
    );
}
